
// CSS
import "../Page/Page.css"
import "./QuoteComp.css"

// React
import React from "react";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


interface imageObj {
  width?: string | number;
  text: string;
  isQuote?: boolean;
  iconPath?: IconProp; // Optional icon prop
}

const QuoteComp: React.FC<imageObj> = ({ width, text, isQuote = false, iconPath }) => {
  return (
    <div className="quoteContainer">
      <div className="quoteBackground">
        {iconPath ? (
          <div className="icon-div">
            <FontAwesomeIcon icon={iconPath} size="2x" />
            <p className="quote">
              {isQuote ? `"${text}"` : text}
            </p>
          </div>
        ) : (
          <text className="quote">
            {isQuote ? `"${text}"` : text}
          </text>
        )}
      </div>
    </div>
  );
};

export default QuoteComp;



